export default __webpack_public_path__ + "static/media/Pos5.37711178.svg";